import {
  createNewOrder,
  getOrderDetails,
  getServiceCategories,
  getServiceList,
  getUserAddressList,
  getVehicleServiceList,
} from "../action";
import {
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  FormHelperText,
  Typography,
  Autocomplete,
  TextField,
  Paper,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  InputAdornment,
  Tabs,
  Tab,
  Chip,
} from "@mui/material";
import dayjs from "dayjs";
import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import { styles } from "./styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Loader from "components/loader";
import React, { useRef, useState } from "react";
import ROUTE_NAMES from "routes/routeNames";
import { useNavigate } from "react-router-dom";
import {
  createOrderSchema,
  editMerchantOnlySchema,
  editOrderDetailsSchema,
} from "utils/schema";
import UserDopdown from "components/userDropdown";
import {
  ADDRESS_TYPE,
  ADDRESS_TYPE_LABEL,
  DISCOUNT_STATUS,
  PAYMENT_MODE_OPTIONS,
  USER_TYPE,
} from "utils/userType";
import AnimateButton from "components/animateButton";
import { useDispatch, useSelector } from "react-redux";
import { getUsersVechiles } from "modules/company/action";
import {
  AddressItem,
  ReducersModal,
  ServiceModal,
  UserDetailModal,
} from "utils/modals";
import AddUserVehicleModal from "./AddUserVehicleModal";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  DatePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/x-date-pickers";
import {
  defaultEditPermissions,
  formatAddressLabel,
  formatCurrency,
  isVehicleCategory,
  parseSelectedAddressType,
} from "utils/commonFunctions";
import {
  getServiceCategoryFromCategoryName,
  resolveCouponListCategory,
  SERVICE_CATEGORY,
} from "utils/serviceCategory";
import { getCouponList } from "modules/coupon/action";
import { CouponListItem } from "utils/modals";
import GoogleAutComplete from "components/googleAutocomplete";
import CloseIcon from "@mui/icons-material/Close";
import { PATCH_API_CALL } from "utils/services";
// import { PUT_API_CALL } from "utils/services";
import SHOW_TOAST from "utils/showToast";
import {
  findCouponById,
  mapOrderDetailForCreateForm,
  readOrderCoupon,
  readOrderCouponId,
} from "utils/apiMappers";
import { ENDPOINTS } from "utils/endpoints";
import { emptyAddressFields, INITIAL_VALUES, TAX_PERCENT } from "utils/constants";
import { toast } from "react-toastify";

const getServiceOptionId = (service?: ServiceModal | any) =>
  `${service?._id || service?.id || service?.serviceId || ""}`.trim();

const emptyNewAddressDraft = {
  addressLine1: "",
  addressLine2: "",
  city: "",
  state: "",
  pincode: "",
  latitude: "",
  longitude: "",
  addressType: "",
};

type PricingTab = "discount" | "coupon";

const computeDiscountAmount = (
  servicePrice: number,
  tab: PricingTab,
  discountValue: number,
  coupon?: CouponListItem | null,
) => {
  if (tab === "coupon") {
    if (!coupon) return 0;
    const couponValue = Number(coupon.couponValue) || 0;
    if (coupon.isPercentage) {
      return Math.max(0, (servicePrice * couponValue) / 100);
    }
    return Math.max(0, couponValue);
  }
  return Math.max(0, Number(discountValue) || 0);
};

const SectionCard = ({
  title,
  subtitle,
  children,
  rightTopComponent,
}: {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  rightTopComponent?: React.ReactNode;
}) => (
  <Paper
    elevation={0}
    sx={{
      p: 2.5,
      mb: 2.5,
      border: "1px solid",
      borderColor: "divider",
      borderRadius: 2,
    }}
  >
    <Box mb={2}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Box>
          <Typography variant="h6" fontWeight={700} sx={{ fontSize: 18 }}>
            {title}
          </Typography>
          {subtitle ? (
            <Typography variant="body2" color="text.secondary" mt={0.5}>
              {subtitle}
            </Typography>
          ) : null}
        </Box>
        {rightTopComponent}
      </Box>
    </Box>
    <Divider sx={{ mb: 2 }} />
    {children}
  </Paper>
);

const CreateOrder = () => {
  const navigation = useNavigate();
  const dispatch: any = useDispatch();
  const orderId = new URLSearchParams(window.location.search).get("orderId");
  const isEditMode = Boolean(orderId);

  const [loading, setLoading] = useState(false);
  const [orderLoaded, setOrderLoaded] = useState(!isEditMode);
  const [formInitialValues, setFormInitialValues] = useState(INITIAL_VALUES);
  const [editPermissions, setEditPermissions] = useState(
    defaultEditPermissions,
  );
  const [userVechilesList, setUserVechleList] = useState<any[]>([]);
  const [addressList, setAddressList] = useState<AddressItem[]>([]);
  const [addressModalOpen, setAddressModalOpen] = useState(false);
  const [addVehicleModalOpen, setAddVehicleModalOpen] = useState(false);
  const [editServiceOption, setEditServiceOption] =
    useState<ServiceModal | null>(null);
  const [selectedCustomer, setSelectedCustomer] =
    useState<UserDetailModal | null>(null);
  const [selectedFranchise, setSelectedFranchise] =
    useState<UserDetailModal | null>(null);
  const [newAddressDraft, setNewAddressDraft] = useState(emptyNewAddressDraft);

  const { createOrder } = useSelector(
    (state: ReducersModal) => state.OrderManagementReducer,
  );

  const [priceDetails, setPriceDetails] = useState({
    tax: "0",
    discount: "0",
    finalPrice: "0",
    servicePrice: "0",
  });
  const [couponOptions, setCouponOptions] = useState<CouponListItem[]>([]);
  const [couponSearchLoading, setCouponSearchLoading] = useState(false);
  const [pricingTab, setPricingTab] = useState<PricingTab>("coupon");
  /** Edit mode: driven by discountMeta.isPercentage (false = flat, true = coupon). */
  const [editIsFlatDiscount, setEditIsFlatDiscount] = useState(false);
  const pricingTabRef = useRef<PricingTab>("coupon");
  const couponSearchTimerRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );
  const couponCategoryRef = useRef("");
  const servicePriceRef = useRef(0);

  React.useEffect(() => {
    if (!isEditMode) {
      dispatch(getServiceCategories(() => { }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditMode]);

  React.useEffect(() => {
    if (!isEditMode || !orderId) return;
    setLoading(true);
    dispatch(
      getOrderDetails(orderId, (result: any) => {
        if (result) {
          const details = mapOrderDetailForCreateForm(result);
          setFormInitialValues(details.formValues);
          setEditPermissions(details.editPermissions || defaultEditPermissions);
          setSelectedCustomer(
            details.selectedCustomer as UserDetailModal | null,
          );
          setSelectedFranchise(
            details.selectedFranchise as UserDetailModal | null,
          );
          setEditServiceOption(details.serviceOption as ServiceModal | null);
          if (details.vehicleOption) {
            setUserVechleList([details.vehicleOption]);
          }
          if (
            details.editPermissions?.canEditOrderDetails &&
            details.formValues.userId
          ) {
            dispatch(
              getUserAddressList(
                details.formValues.userId,
                (list: AddressItem[]) => {
                  const mapped = list || [];
                  if (
                    details.addressOption &&
                    !mapped.some((a) => a._id === details.addressOption?._id)
                  ) {
                    setAddressList([details.addressOption, ...mapped]);
                  } else {
                    setAddressList(mapped);
                  }
                },
              ),
            );
          } else if (details.addressOption) {
            setAddressList([details.addressOption]);
          } else if (
            details.formValues.addressLine1 ||
            details.formValues.city
          ) {
            setAddressList([]);
          }
          const servicePrice = Number(details.formValues.price) || 0;
          // discountMeta.isPercentage === false → flat; true → coupon only.
          const isFlat =
            Boolean(details.isFlatDiscount) ||
            Boolean(details.formValues?.isFlatDiscount);
          setEditIsFlatDiscount(isFlat);

          if (isFlat) {
            setCouponOptions([]);
            setFormInitialValues((prev: any) => ({
              ...prev,
              couponCode: "",
              couponId: "",
              isFlatDiscount: true,
              isPercentage: false,
              discountValue: Number(details.formValues.discountValue) || 0,
            }));
            recalculatePrice(
              servicePrice,
              Number(details.formValues.discountValue) || 0,
            );
          } else {
            const storedCouponId = `${details.formValues.couponId || readOrderCouponId(orderId) || ""
              }`.trim();
            const storedCoupon = readOrderCoupon(orderId);
            const appliedCoupon =
              storedCoupon || details.couponOption || null;
            const discountAmount = appliedCoupon?.couponCode
              ? computeDiscountAmount(servicePrice, "coupon", 0, appliedCoupon)
              : Number(details.formValues.discountValue) || 0;
            recalculatePrice(servicePrice, discountAmount);
            if (appliedCoupon?.couponCode) {
              setFormInitialValues((prev: any) => ({
                ...prev,
                couponCode: appliedCoupon.couponCode,
                couponId:
                  appliedCoupon._id || appliedCoupon.id || storedCouponId,
                isFlatDiscount: false,
                isPercentage: true,
              }));
              setCouponOptions((prev) =>
                mergeCouponOptions(prev, appliedCoupon),
              );
            }
            // Only load coupon list for percentage/coupon orders — never for flat.
            loadCouponsForCategory(
              details.formValues.serviceCategory,
              undefined,
              appliedCoupon,
              storedCouponId,
            );
          }
        }
        setOrderLoaded(true);
        setLoading(false);
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditMode, orderId]);

  const recalculatePrice = (servicePrice: number, discountValue: number) => {
    const discount = Math.max(0, Number(discountValue) || 0);
    const afterDiscount = Math.max(0, servicePrice - discount);
    const tax = afterDiscount * (TAX_PERCENT / 100);
    servicePriceRef.current = servicePrice;
    setPriceDetails({
      servicePrice: `${servicePrice}`,
      discount: `${discount}`,
      tax: `${tax.toFixed(2)}`,
      finalPrice: `${(afterDiscount + tax).toFixed(2)}`,
    });
  };

  const clearServiceSelection = (setFieldValue: any) => {
    setFieldValue("serviceId", "");
    setFieldValue("price", 0);
    setPriceDetails({
      tax: "0",
      discount: "0",
      finalPrice: "0",
      servicePrice: "0",
    });
  };

  const applyAddressToForm = (setFieldValue: any, addr: AddressItem | null) => {
    if (!addr) {
      Object.entries(emptyAddressFields).forEach(([key, value]) => {
        setFieldValue(key, value);
      });
      setFieldValue("addressType", "");
      return;
    }
    const [lng = "", lat = ""] = addr.location?.coordinates || [];
    const savedAddressType = parseSelectedAddressType(addr.addressType);
    setFieldValue("addressId", addr._id || "");
    setFieldValue("addressLine1", addr.addressLine1 || "");
    setFieldValue("addressLine2", addr.addressLine2 || "");
    setFieldValue("city", addr.city || "");
    setFieldValue("state", addr.state || "");
    setFieldValue("pincode", addr.pincode || "");
    setFieldValue("longitude", lng != null ? String(lng) : "");
    setFieldValue("latitude", lat != null ? String(lat) : "");
    setFieldValue(
      "addressType",
      savedAddressType !== undefined ? `${savedAddressType}` : "",
    );
  };

  const fetchAddresses = (userId: string, setFieldValue: any) => {
    if (!userId) {
      setAddressList([]);
      applyAddressToForm(setFieldValue, null);
      return;
    }
    setLoading(true);
    dispatch(
      getUserAddressList(userId, (list: AddressItem[]) => {
        setAddressList(list || []);
        const defaultAddress =
          (list || []).find((a) => a.isDefault) || (list || [])[0] || null;
        applyAddressToForm(setFieldValue, defaultAddress);
        setLoading(false);
      }),
    );
  };

  const getVechiles = (params: any, onDone?: (result: any[]) => void) => {
    setLoading(true);
    dispatch(
      getUsersVechiles({
        data: params,
        callback: (result: any) => {
          const list = result || [];
          setUserVechleList(list);
          setLoading(false);
          onDone?.(list);
        },
      }),
    );
  };

  const openAddVehicleModal = () => {
    setAddVehicleModalOpen(true);
  };

  const mergeCouponOptions = (
    list: CouponListItem[],
    applied?: CouponListItem | null,
  ) => {
    if (!applied?.couponCode) return list;
    const exists = list.some((item) => item.couponCode === applied.couponCode);
    return exists ? list : [applied, ...list];
  };

  const loadCouponsForCategory = (
    categoryName: string,
    setFieldValue?: any,
    applied?: CouponListItem | null,
    couponId?: string,
    search: string = "",
    autoSelect: boolean = true,
  ) => {
    const category = resolveCouponListCategory(categoryName);
    couponCategoryRef.current = categoryName || "";
    if (!category) {
      setCouponOptions(applied?.couponCode ? [applied] : []);
      setCouponSearchLoading(false);
      return;
    }
    const searchTerm = `${search || ""}`.trim();
    setCouponSearchLoading(true);
    dispatch(
      getCouponList({
        isolated: true,
        page: 1,
        limit: 50,
        category,
        status: DISCOUNT_STATUS.ACTIVE,
        ...(searchTerm ? { search: searchTerm } : {}),
        callback: (mapped: any) => {
          setCouponSearchLoading(false);
          const rows = mapped?.result || [];
          const fromList = findCouponById(rows, couponId);
          // Create mode may fall back to default coupon; edit mode must only
          // use the coupon already on the order (never invent a default).
          const defaultCoupon =
            !isEditMode && autoSelect && !searchTerm
              ? rows.find((item: CouponListItem) => item?.isDefault) || null
              : null;
          const selected = fromList || applied || defaultCoupon || null;
          setCouponOptions(mergeCouponOptions(rows, selected));
          if (autoSelect && selected?.couponCode) {
            if (setFieldValue) {
              setFieldValue("couponCode", selected.couponCode);
              setFieldValue(
                "couponId",
                selected._id || selected.id || couponId || "",
              );
            } else {
              setFormInitialValues((prev: any) => ({
                ...prev,
                couponCode: selected.couponCode,
                couponId: selected._id || selected.id || couponId || "",
              }));
            }
          }
          if (
            autoSelect &&
            !isEditMode &&
            pricingTabRef.current === "coupon"
          ) {
            const servicePrice = servicePriceRef.current;
            recalculatePrice(
              servicePrice,
              computeDiscountAmount(servicePrice, "coupon", 0, selected),
            );
          }
        },
      }),
    );
  };

  const searchCoupons = (
    categoryName: string,
    search: string,
    selectedCoupon?: CouponListItem | null,
  ) => {
    if (couponSearchTimerRef.current) {
      clearTimeout(couponSearchTimerRef.current);
      couponSearchTimerRef.current = null;
    }
    couponSearchTimerRef.current = setTimeout(() => {
      loadCouponsForCategory(
        categoryName,
        undefined,
        selectedCoupon || null,
        selectedCoupon?._id || selectedCoupon?.id || "",
        search,
        false,
      );
    }, 400);
  };

  React.useEffect(() => {
    return () => {
      if (couponSearchTimerRef.current) {
        clearTimeout(couponSearchTimerRef.current);
      }
    };
  }, []);

  const resetVehicleAndService = (setFieldValue: any) => {
    setFieldValue("vechileId", "");
    setFieldValue("vehicleRegNo", "");
    setFieldValue("couponCode", "");
    setFieldValue("couponId", "");
    clearServiceSelection(setFieldValue);
    setUserVechleList([]);
    setCouponOptions([]);
  };

  const handleOnSubmit = (values: any) => {
    if (isEditMode && orderId) {
      if (editPermissions.isFullyLocked) {
        SHOW_TOAST(
          "This order was cancelled by the service partner and cannot be edited.",
          "error",
        );
        return;
      }

      const initial = formInitialValues || {};
      const isChanged = (key: string) =>
        String(values?.[key] ?? "") !== String(initial?.[key] ?? "");

      const payload: any = {};

      if (editPermissions.canEditMerchant && isChanged("franchiseId")) {
        payload.merchantId = values.franchiseId || null;
      }

      if (editPermissions.canEditOrderDetails) {
        if (isChanged("vehicleRegNo")) {
          payload.vehicleRegistrationNumber = values.vehicleRegNo || "";
        }

        if (isChanged("serviceDate")) {
          payload.serviceDate = values.serviceDate || "";
        }

        if (isChanged("serviceTime")) {
          payload.serviceTime = values.serviceTime
            ? moment(values.serviceTime, "HH:mm").format("hh:mm A")
            : "";
        }

        const addressFieldsChanged =
          isChanged("addressLine1") ||
          isChanged("addressLine2") ||
          isChanged("city") ||
          isChanged("state") ||
          isChanged("pincode") ||
          isChanged("addressType") ||
          isChanged("latitude") ||
          isChanged("longitude") ||
          isChanged("addressId");

        if (addressFieldsChanged) {
          const address: any = {};

          if (isChanged("addressLine1")) {
            address.addressLine1 = values.addressLine1 || "";
          }
          if (isChanged("addressLine2")) {
            address.addressLine2 = values.addressLine2 || "";
          }
          if (isChanged("city")) {
            address.city = values.city || "";
          }
          if (isChanged("state")) {
            address.state = values.state || "";
          }
          if (isChanged("pincode")) {
            address.pincode = `${values.pincode || ""}`;
          }
          if (isChanged("addressType")) {
            const addressType = parseSelectedAddressType(values.addressType);
            if (addressType !== undefined) {
              address.addressType = addressType;
            }
          }

          // New/changed saved address selection — include all address fields
          if (isChanged("addressId")) {
            address.firstName =
              selectedCustomer?.firstName || selectedCustomer?.fullName || "";
            address.addressLine1 = values.addressLine1 || "";
            address.addressLine2 = values.addressLine2 || "";
            address.city = values.city || "";
            address.state = values.state || "";
            address.pincode = `${values.pincode || ""}`;
            const addressType = parseSelectedAddressType(values.addressType);
            if (addressType !== undefined) {
              address.addressType = addressType;
            }
            address.location = {
              latitude: values.latitude ? String(values.latitude) : "",
              longitude: values.longitude ? String(values.longitude) : "",
            };
          } else if (isChanged("latitude") || isChanged("longitude")) {
            address.location = {};
            if (isChanged("latitude")) {
              address.location.latitude = values.latitude
                ? String(values.latitude)
                : "";
            }
            if (isChanged("longitude")) {
              address.location.longitude = values.longitude
                ? String(values.longitude)
                : "";
            }
          }

          if (Object.keys(address).length) {
            payload.address = address;
          }
        }

        // Coupon is not sent on update order
        // if (isChanged("couponCode")) {
        //   const selectedFromList = couponOptions.find(
        //     (item) => item.couponCode === `${values.couponCode || ""}`.trim()
        //   );
        //   if (selectedFromList?.couponCode) {
        //     payload.coupon = { couponCode: selectedFromList.couponCode };
        //   }
        // }
      }

      if (!Object.keys(payload).length) {
        SHOW_TOAST("No changes to update", "error");
        return;
      }

      setLoading(true);
      PATCH_API_CALL(
        `${ENDPOINTS.ORDER_MANAGEMENT.UPDATE_ORDER_DETAILS}/${orderId}`,
        payload,
        (response: any) => {
          setLoading(false);
          if (response?.isSuccess) {
            // Coupon is not updated on edit order
            // const nextCouponId = `${
            //   values.couponId ||
            //   couponOptions.find(
            //     (item) => item.couponCode === `${values.couponCode || ""}`.trim()
            //   )?._id ||
            //   ""
            // }`.trim();
            // persistOrderCoupon(
            //   orderId,
            //   couponOptions.find(
            //     (item) => item.couponCode === `${values.couponCode || ""}`.trim()
            //   ) || { _id: nextCouponId, couponCode: values.couponCode }
            // );
            SHOW_TOAST(response?.data?.message, "success");
            navigation(ROUTE_NAMES.MAIN_ROUTES.ORDER);
          }
        },
      );
      return;
    }

    const slotDate = values.serviceDate
      ? moment(values.serviceDate, "YYYY-MM-DD").format("YYYY-MM-DD")
      : "";
    const slotTime = values.serviceTime
      ? moment(
        `${values.serviceDate || moment().format("YYYY-MM-DD")} ${values.serviceTime
        }`,
        "YYYY-MM-DD HH:mm",
      ).toISOString()
      : "";

    const payload: any = {
      userId: values.userId,
      paymentMode: `${values.paymentMode}`,
      franchiseId: values.franchiseId,
      serviceId: values.serviceId,
      slot: {
        date: slotDate,
        time: slotTime,
      },
      hashCode: crypto.randomUUID(),
    };

    // Existing saved address → only addressId
    // New Google/autocomplete address → only address object (no addressId)

    if (values.addressId) {
      payload.addressId = values.addressId;
    } else {
      const addressType = parseSelectedAddressType(values.addressType);
      payload.address = {
        addressLine1: values.addressLine1,
        addressLine2: values.addressLine2 || "",
        city: values.city,
        state: values.state,
        pincode: `${values.pincode}`,
        location: {
          coordinates: [
            values.longitude ? String(values.longitude) : "",
            values.latitude ? String(values.latitude) : "",
          ],
        },
        ...(addressType !== undefined ? { addressType } : {}),
      };
    }

    if (isVehicleCategory(values.serviceCategory)) {
      payload.userVehicleId = values.vechileId;
      payload.vehicleRegistrationNumber = values.vehicleRegNo;
    }

    const discountValue = Number(values.discountValue) || 0;
    const couponCode = `${values.couponCode || ""}`.trim();
    const selectedFromList = couponOptions.find(
      (item) => item.couponCode === couponCode,
    );

    if (pricingTab === "discount") {
      if (discountValue > 0) {
        payload.discount = discountValue;
      }
    } else if (selectedFromList?.couponCode) {
      payload.coupon = { couponCode: selectedFromList.couponCode };
    }
    setLoading(true);
    dispatch(
      createNewOrder(payload, (created: any) => {
        // console.log("created in createNewOrder :::", created);
        // debugger;
        setLoading(false);
        const createdOrderId = `${created?.orderId ||
          created?._id ||
          created?.data?.orderId ||
          created?.result?.orderId ||
          ""
          }`.trim();
        if (!createdOrderId) {
          // navigation(ROUTE_NAMES.MAIN_ROUTES.ORDER);
          return;
        }
        navigation(
          `${ROUTE_NAMES.MAIN_ROUTES.ORDER_DETAIL}?orderId=${createdOrderId}`,
          {
            state: {
              couponDetails:
                pricingTab === "coupon" ? selectedFromList || null : null,
            },
          },
        );
      }),
    );
  };

  const openAddAddressModal = () => {
    setNewAddressDraft(emptyNewAddressDraft);
    setAddressModalOpen(true);
  };

  const confirmNewAddress = (setFieldValue: any) => {
    const addressType = parseSelectedAddressType(newAddressDraft.addressType);
    if (addressType === undefined) return;

    setFieldValue("addressId", "");
    setFieldValue("addressLine1", newAddressDraft.addressLine1);
    setFieldValue("addressLine2", newAddressDraft.addressLine2);
    setFieldValue("city", newAddressDraft.city);
    setFieldValue("state", newAddressDraft.state);
    setFieldValue("pincode", newAddressDraft.pincode);
    setFieldValue("latitude", newAddressDraft.latitude);
    setFieldValue("longitude", newAddressDraft.longitude);
    setFieldValue("addressType", `${addressType}`);
    setAddressModalOpen(false);
  };

  if (isEditMode && !orderLoaded) {
    return <Loader />;
  }

  const getEditValidationSchema = () => {
    if (editPermissions.canEditOrderDetails) return editOrderDetailsSchema;
    if (editPermissions.canEditMerchant) return editMerchantOnlySchema;
    return Yup.object().shape({});
  };
  return (
    <Formik
      onSubmit={handleOnSubmit}
      initialValues={formInitialValues}
      enableReinitialize
      validationSchema={
        isEditMode ? getEditValidationSchema() : createOrderSchema
      }
    >
      {({
        errors,
        values,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
        setFieldTouched,
        setFieldError,
      }) => {
        const vehicleFlow =
          isVehicleCategory(values.serviceCategory) ||
          (isEditMode && Boolean(values.vechileId));
        const hasUser = Boolean(values.userId);
        const hasCategory = Boolean(values.serviceCategory);
        const hasVehicle = Boolean(values.vechileId);
        const serviceEnabled = vehicleFlow
          ? hasUser && hasCategory && hasVehicle
          : hasUser && hasCategory;
        const selectedAddress =
          addressList.find((a) => a._id === values.addressId) || null;
        const selectedCoupon =
          couponOptions.find((item) => item.couponCode === values.couponCode) ||
          null;
        const serviceOptions = editServiceOption
          ? [
            editServiceOption,
            ...(createOrder.serviceList || []).filter(
              (s) => s._id !== editServiceOption._id,
            ),
          ]
          : createOrder.serviceList || [];
        const isFullyLocked = isEditMode && editPermissions.isFullyLocked;
        const fieldsLocked = isEditMode;
        const merchantLocked =
          isFullyLocked || (isEditMode && !editPermissions.canEditMerchant);
        const orderDetailsLocked =
          isFullyLocked ||
          (isEditMode && !editPermissions.canEditOrderDetails);
        // Create: address fields are display-only — set via Saved Address or Add New Address modal.
        const addressManualLocked = !isEditMode || orderDetailsLocked;
        const canSubmitEdit =
          !isFullyLocked &&
          (editPermissions.canEditMerchant ||
            editPermissions.canEditOrderDetails);

        return (
          <form noValidate onSubmit={handleSubmit}>
            <SectionCard
              title="Customer & Franchise"
              subtitle={
                isEditMode
                  ? isFullyLocked
                    ? "This order was cancelled by the service partner. Editing is not allowed."
                    : merchantLocked
                      ? "Franchise can be reassigned only when the order is placed or rejected by franchise, and the service is scheduled for a later day."
                      : "You can reassign the franchise for this order."
                  : "Select the customer and franchise before configuring the service."
              }
            >
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    <UserDopdown
                      userType={USER_TYPE.CUSTOMER}
                      disabled={fieldsLocked}
                      selectedUser={selectedCustomer}
                      onSelectUser={(user: UserDetailModal | null) => {
                        if (fieldsLocked) return;
                        setSelectedCustomer(user);
                        const userId = user?.id || "";
                        setFieldValue("userId", userId);
                        setFieldValue("serviceCategory", "");
                        resetVehicleAndService(setFieldValue);
                        fetchAddresses(userId, setFieldValue);
                      }}
                    />
                    {touched.userId && errors.userId && (
                      <FormHelperText error>
                        {errors?.userId?.toString()}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    <UserDopdown
                      userType={USER_TYPE.MERCHANT}
                      disabled={merchantLocked}
                      selectedUser={selectedFranchise}
                      onSelectUser={(user: UserDetailModal | null) => {
                        if (merchantLocked) return;
                        setSelectedFranchise(user);
                        setFieldValue("franchiseId", user?.id || "");
                      }}
                    />
                    {touched.franchiseId && errors.franchiseId && (
                      <FormHelperText error>
                        {errors?.franchiseId?.toString()}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    <InputLabel>Payment Mode</InputLabel>
                    <Select
                      sx={styles.selectDropdown}
                      label="Payment Mode"
                      name="paymentMode"
                      value={values.paymentMode}
                      disabled={fieldsLocked}
                      onChange={(e) =>
                        setFieldValue("paymentMode", e.target.value)
                      }
                    >
                      {PAYMENT_MODE_OPTIONS.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                    {touched.paymentMode && errors.paymentMode && (
                      <FormHelperText error>
                        {errors?.paymentMode?.toString()}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
              </Grid>
            </SectionCard>

            <SectionCard
              title="Service"
              subtitle={
                vehicleFlow
                  ? "For Car & Bike, select the user vehicle first, then choose a service for that vehicle."
                  : "Select a category, then choose the service."
              }
              rightTopComponent={<Grid
                item
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                }}
              >
                <Button
                  fullWidth
                  variant="outlined"
                  disabled={fieldsLocked || !hasUser}
                  onClick={openAddVehicleModal}
                  sx={{ borderRadius: "12px", height: "53px", color: "primary.main" }}
                >
                  Add Vehicle
                </Button>
              </Grid>}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth disabled={fieldsLocked || !hasUser}>
                    <InputLabel>Service Category</InputLabel>
                    <Select
                      sx={styles.selectDropdown}
                      label="Service Category"
                      name="serviceCategory"
                      value={values.serviceCategory}
                      disabled={fieldsLocked || !hasUser}
                      onChange={(e: any) => {
                        if (fieldsLocked) return;
                        const categoryName = e.target.value;
                        setFieldValue("serviceCategory", categoryName);
                        resetVehicleAndService(setFieldValue);
                        setFieldTouched("serviceId", false, false);
                        setFieldError("serviceId", undefined);
                        loadCouponsForCategory(categoryName, setFieldValue);

                        const category =
                          getServiceCategoryFromCategoryName(categoryName);
                        if (
                          category === SERVICE_CATEGORY.CAR ||
                          category === SERVICE_CATEGORY.BIKE
                        ) {
                          if (values.userId) {
                            getVechiles({
                              page: 1,
                              userId: values.userId,
                              vehicleType: category.toString(),
                            });
                          }
                        } else {
                          setLoading(true);
                          dispatch(
                            getServiceList(() => {
                              setLoading(false);
                            }, category.toString()),
                          );
                        }
                      }}
                    >
                      {(createOrder?.serviceCategoryList || []).length > 0
                        ? (createOrder?.serviceCategoryList || []).map(
                          (item) => (
                            <MenuItem
                              key={item._id}
                              value={item.categoryName}
                            >
                              {item.categoryName}
                            </MenuItem>
                          ),
                        )
                        : values.serviceCategory
                          ? [
                            <MenuItem
                              key={values.serviceCategory}
                              value={values.serviceCategory}
                            >
                              {values.serviceCategory}
                            </MenuItem>,
                          ]
                          : null}
                    </Select>
                    {touched.serviceCategory && errors.serviceCategory && (
                      <FormHelperText error>
                        {errors?.serviceCategory?.toString()}
                      </FormHelperText>
                    )}
                    {!hasUser && (
                      <FormHelperText>
                        Select a user to enable category
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                {vehicleFlow && (
                  <>
                    <Grid item xs={12} md={4}>
                      <FormControl fullWidth>
                        <Autocomplete
                          disabled={fieldsLocked || !hasUser || !hasCategory}
                          options={userVechilesList}
                          value={
                            userVechilesList.find(
                              (a) => a.id === values.vechileId,
                            ) || null
                          }
                          onChange={(_, value) => {
                            if (fieldsLocked) return;
                            const vehicleId =
                              value?.userVehicleId || value?.id || "";
                            setFieldValue("vechileId", vehicleId);
                            setFieldValue(
                              "vehicleRegNo",
                              value?.registrationNumber ||
                              value?.vehicleRegistrationNumber ||
                              "",
                            );
                            clearServiceSelection(setFieldValue);
                            if (vehicleId) {
                              setLoading(true);
                              dispatch(
                                getVehicleServiceList(vehicleId, () => {
                                  setLoading(false);
                                }),
                              );
                            }
                          }}
                          getOptionLabel={(option: any) => {
                            const name =
                              option?.name || option?.vehicleName || "";
                            const reg =
                              option?.registrationNumber ||
                              option?.vehicleRegistrationNumber ||
                              "";
                            return reg ? `${name} (${reg})` : name;
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              label="Select Vehicle"
                              helperText={
                                !hasUser || !hasCategory
                                  ? "Select user and category first"
                                  : ""
                              }
                            />
                          )}
                        />
                        {touched.vechileId && errors.vechileId && (
                          <FormHelperText error>
                            {errors?.vechileId?.toString()}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <FormControl fullWidth>
                        <TextField
                          type="text"
                          name="vehicleRegNo"
                          variant="outlined"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.vehicleRegNo}
                          label="Vehicle Registration Number"
                          disabled={
                            isEditMode ? orderDetailsLocked : !hasVehicle
                          }
                        />
                        {touched.vehicleRegNo && errors.vehicleRegNo && (
                          <FormHelperText error>
                            {errors?.vehicleRegNo?.toString()}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                  </>
                )}

                <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    <Autocomplete
                      key={values.serviceCategory || "service"}
                      disabled={fieldsLocked || !serviceEnabled}
                      options={serviceOptions}
                      value={
                        serviceOptions.find(
                          (a) => getServiceOptionId(a) === values.serviceId,
                        ) || null
                      }
                      isOptionEqualToValue={(option, value) =>
                        getServiceOptionId(option) === getServiceOptionId(value)
                      }
                      onChange={(_, value: ServiceModal | null) => {
                        if (fieldsLocked) return;
                        if (!value) {
                          if (!serviceOptions.length) {
                            return;
                          }
                          clearServiceSelection(setFieldValue);
                          return;
                        }
                        const nextServiceId = getServiceOptionId(value);
                        setFieldValue("serviceId", nextServiceId);
                        setFieldError("serviceId", undefined);
                        const price = Number(value?.price) || 0;
                        setFieldValue("price", price);
                        const selected =
                          couponOptions.find(
                            (item) => item.couponCode === values.couponCode,
                          ) || null;
                        recalculatePrice(
                          price,
                          computeDiscountAmount(
                            price,
                            isEditMode ? "discount" : pricingTab,
                            Number(values.discountValue) || 0,
                            selected,
                          ),
                        );
                      }}
                      getOptionLabel={(option: ServiceModal) => {
                        const name =
                          option?.serviceName ||
                          (option as any)?.serviceType ||
                          (option as any)?.title ||
                          "";
                        return name
                          ? `${name}${option.price != null
                            ? ` — ${formatCurrency(Number(option.price))}`
                            : ""
                          }`
                          : "";
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label="Service"
                          helperText={
                            !serviceEnabled
                              ? vehicleFlow
                                ? "Select vehicle to load services"
                                : "Select category to load services"
                              : ""
                          }
                        />
                      )}
                    />
                    {touched.serviceId && errors.serviceId && (
                      <FormHelperText error>
                        {errors?.serviceId?.toString()}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
              </Grid>
            </SectionCard>

            <SectionCard
              title="Schedule"
              subtitle={
                isEditMode
                  ? isFullyLocked
                    ? "This order was cancelled by the service partner. Editing is not allowed."
                    : orderDetailsLocked
                      ? !(
                          editPermissions.isScheduleOnNextDayOrLater ??
                          editPermissions.isScheduleBeyond24Hours
                        )
                        ? "Schedule can only be updated when the service is scheduled for a later day."
                        : "Assign a franchise first. Schedule and address unlock after a franchise is assigned."
                      : "Update the service date and time. Date must be tomorrow or later."
                  : "Pick the service slot. Date must be tomorrow or later."
              }
            >
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Service Date"
                        disabled={orderDetailsLocked}
                        onChange={(newValue) => {
                          if (orderDetailsLocked || !newValue) return;
                          setFieldValue(
                            "serviceDate",
                            moment(newValue.toDate()).format("YYYY-MM-DD"),
                          );
                        }}
                        minDate={dayjs().add(1, "day")}
                        maxDate={
                          isEditMode ? undefined : dayjs().add(30, "day")
                        }
                        value={
                          values?.serviceDate?.length > 0
                            ? dayjs(values.serviceDate, "YYYY-MM-DD")
                            : null
                        }
                      />
                    </LocalizationProvider>
                    {touched.serviceDate && errors.serviceDate && (
                      <FormHelperText error>
                        {errors?.serviceDate?.toString()}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        label="Service Time"
                        disabled={orderDetailsLocked}
                        onChange={(newValue) => {
                          if (orderDetailsLocked || !newValue) return;
                          setFieldValue(
                            "serviceTime",
                            moment(newValue.toDate()).format("HH:mm"),
                          );
                        }}
                        value={
                          values?.serviceTime?.length > 0
                            ? dayjs(values.serviceTime, "HH:mm")
                            : null
                        }
                      />
                    </LocalizationProvider>
                    {touched.serviceTime && errors.serviceTime && (
                      <FormHelperText error>
                        {errors?.serviceTime?.toString()}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
              </Grid>
            </SectionCard>

            <SectionCard
              title="Address"
              subtitle={
                isEditMode && isFullyLocked
                  ? "This order was cancelled by the service partner. Editing is not allowed."
                  : isEditMode && orderDetailsLocked
                    ? !(
                        editPermissions.isScheduleOnNextDayOrLater ??
                        editPermissions.isScheduleBeyond24Hours
                      )
                      ? "Address can only be updated when the service is scheduled for a later day."
                      : "Assign a franchise first. Address unlocks after a franchise is assigned."
                    : "Choose a saved address or add a new one from the modal. Address fields cannot be typed manually."
              }
            >
              <Grid container spacing={2}>
                {/* Row 1: Saved address dropdown + Add new address button */}
                <Grid item xs={12} md={8}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel id="saved-address-label" shrink>
                      Saved Address
                    </InputLabel>
                    <Select
                      sx={styles.selectDropdown}
                      labelId="saved-address-label"
                      label="Saved Address"
                      notched
                      displayEmpty
                      value={values.addressId || ""}
                      disabled={orderDetailsLocked || !hasUser}
                      onChange={(e) => {
                        if (orderDetailsLocked) return;
                        const value = e.target.value;
                        const selected =
                          addressList.find((a) => a._id === value) || null;
                        applyAddressToForm(setFieldValue, selected);
                      }}
                      renderValue={(selected) => {
                        if (!selected) {
                          return values.addressLine1
                            ? `New: ${values.addressLine1}`
                            : "Select address";
                        }
                        const addr = addressList.find(
                          (a) => a._id === selected,
                        );
                        return addr
                          ? `${formatAddressLabel(addr)}${addr.isDefault ? " (Default)" : ""
                          }`
                          : "Select address";
                      }}
                    >
                      <MenuItem value="" disabled>
                        Select address
                      </MenuItem>
                      {(addressList || []).map((addr) => (
                        <MenuItem key={addr._id} value={addr._id}>
                          {formatAddressLabel(addr)}
                          {addr.isDefault ? " (Default)" : ""}
                        </MenuItem>
                      ))}
                    </Select>
                    {!hasUser && (
                      <FormHelperText>
                        Select a user to load addresses
                      </FormHelperText>
                    )}
                    {hasUser && !selectedAddress && !values.addressLine1 && (
                      <FormHelperText>
                        No saved address found — use Add New Address
                      </FormHelperText>
                    )}
                    {!isEditMode && hasUser && (
                      <FormHelperText>
                        Select from Saved Address, or use Add New Address. Manual entry is disabled.
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                  }}
                >
                  <Button
                    fullWidth
                    variant="outlined"
                    disabled={orderDetailsLocked || !hasUser}
                    onClick={openAddAddressModal}
                    sx={{ borderRadius: "12px", height: "49px", color: "primary.main" }}
                  >
                    Add New Address
                  </Button>
                </Grid>

                <Grid item xs={12} md={4}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel id="address-type-label" shrink>
                      Address Type
                    </InputLabel>
                    <Select
                      sx={styles.selectDropdown}
                      labelId="address-type-label"
                      label="Address Type"
                      name="addressType"
                      notched
                      displayEmpty
                      value={values.addressType ?? ""}
                      disabled={
                        addressManualLocked ||
                        (!isEditMode && Boolean(values.addressId))
                      }
                      onChange={(e) => {
                        if (addressManualLocked) return;
                        const addressType = parseSelectedAddressType(
                          e.target.value,
                        );
                        if (addressType === undefined) return;
                        setFieldValue("addressType", `${addressType}`);
                      }}
                      renderValue={(selected) => {
                        if (!selected) return "Select address type";
                        return (
                          ADDRESS_TYPE_LABEL[
                            Number(selected) as ADDRESS_TYPE
                          ] || "Select address type"
                        );
                      }}
                    >
                      <MenuItem value="" disabled>
                        Select address type
                      </MenuItem>
                      {Object.values(ADDRESS_TYPE)
                        .filter((v) => typeof v === "number")
                        .map((type) => (
                          <MenuItem key={type} value={`${type}`}>
                            {ADDRESS_TYPE_LABEL[type as ADDRESS_TYPE]}
                          </MenuItem>
                        ))}
                    </Select>
                    {touched.addressType && errors.addressType && (
                      <FormHelperText error>
                        {errors?.addressType?.toString()}
                      </FormHelperText>
                    )}
                    {!isEditMode && values.addressId ? (
                      <FormHelperText>
                        Comes from the selected saved address.
                      </FormHelperText>
                    ) : null}
                    {!isEditMode && !values.addressId && values.addressLine1 ? (
                      <FormHelperText>
                        Comes from Add New Address. Change it in the modal if needed.
                      </FormHelperText>
                    ) : null}
                  </FormControl>
                </Grid>

                {/* Row 2: Address Line 1 & Address Line 2 (read-only on create) */}
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    name="addressLine1"
                    onBlur={handleBlur}
                    label="Address Line 1"
                    onChange={handleChange}
                    value={values.addressLine1}
                    disabled={addressManualLocked}
                    InputProps={{ readOnly: !isEditMode }}
                  />
                  {touched.addressLine1 && errors.addressLine1 && (
                    <FormHelperText error>
                      {errors?.addressLine1?.toString()}
                    </FormHelperText>
                  )}
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    name="addressLine2"
                    onBlur={handleBlur}
                    label="Address Line 2"
                    onChange={handleChange}
                    value={values.addressLine2}
                    disabled={addressManualLocked}
                    InputProps={{ readOnly: !isEditMode }}
                  />
                </Grid>

                {/* Row 3: City, State, Pincode (read-only on create) */}
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    name="city"
                    label="City"
                    value={values.city}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    disabled={addressManualLocked}
                    InputProps={{ readOnly: !isEditMode }}
                  />
                  {touched.city && errors.city && (
                    <FormHelperText error>
                      {errors?.city?.toString()}
                    </FormHelperText>
                  )}
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    name="state"
                    label="State"
                    onBlur={handleBlur}
                    value={values.state}
                    onChange={handleChange}
                    disabled={addressManualLocked}
                    InputProps={{ readOnly: !isEditMode }}
                  />
                  {touched.state && errors.state && (
                    <FormHelperText error>
                      {errors?.state?.toString()}
                    </FormHelperText>
                  )}
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    type="number"
                    name="pincode"
                    label="Pincode"
                    onBlur={handleBlur}
                    value={values.pincode}
                    onChange={handleChange}
                    disabled={addressManualLocked}
                    InputProps={{ readOnly: !isEditMode }}
                    sx={styles.removeArrow}
                  />
                  {touched.pincode && errors.pincode && (
                    <FormHelperText error>
                      {errors?.pincode?.toString()}
                    </FormHelperText>
                  )}
                </Grid>
              </Grid>
            </SectionCard>

            <SectionCard
              title="Pricing"
              subtitle={
                isEditMode
                  ? editIsFlatDiscount
                    ? "Flat discount applied on this order."
                    : "Applied coupon from this order."
                  : "Apply a flat discount or a coupon. Amount summary updates automatically."
              }
            >
              {!isEditMode && (
                <Tabs
                  value={pricingTab}
                  onChange={(_, nextTab: PricingTab) => {
                    pricingTabRef.current = nextTab;
                    setPricingTab(nextTab);
                    const servicePrice = Number(values.price) || 0;
                    if (nextTab === "coupon") {
                      const nextCoupon =
                        couponOptions.find(
                          (item) => item.couponCode === values.couponCode,
                        ) ||
                        couponOptions.find((item) => item.isDefault) ||
                        null;
                      if (nextCoupon?.couponCode && !values.couponCode) {
                        setFieldValue("couponCode", nextCoupon.couponCode);
                        setFieldValue(
                          "couponId",
                          nextCoupon._id || nextCoupon.id || "",
                        );
                      }
                      recalculatePrice(
                        servicePrice,
                        computeDiscountAmount(
                          servicePrice,
                          "coupon",
                          0,
                          nextCoupon,
                        ),
                      );
                      return;
                    }
                    recalculatePrice(
                      servicePrice,
                      Number(values.discountValue) || 0,
                    );
                  }}
                  textColor="secondary"
                  indicatorColor="secondary"
                  sx={{
                    mb: 2,
                    minHeight: 40,
                    "& .MuiTab-root": {
                      textTransform: "none",
                      fontWeight: 600,
                      minHeight: 40,
                      minWidth: 110,
                    },
                  }}
                >
                  <Tab value="coupon" label="Coupon" />
                  <Tab value="discount" label="Discount" />
                </Tabs>
              )}
              <Grid container spacing={2}>
                {/* Edit: isPercentage false → flat Discount Amount; true → Coupon Code */}
                {isEditMode && !editIsFlatDiscount ? (
                  <Grid item xs={12} md={4}>
                    <TextField
                      fullWidth
                      label="Coupon Code"
                      value={
                        selectedCoupon?.couponCode || values.couponCode || ""
                      }
                      disabled
                      helperText={
                        selectedCoupon
                          ? [
                            selectedCoupon.title,
                            selectedCoupon.isPercentage
                              ? `${selectedCoupon.couponValue}% off`
                              : `${formatCurrency(
                                Number(selectedCoupon.couponValue) || 0,
                              )} off`,
                          ]
                            .filter(Boolean)
                            .join(" · ")
                          : "Applied coupon"
                      }
                    />
                  </Grid>
                ) : null}

                {((isEditMode && editIsFlatDiscount) ||
                  (!isEditMode && pricingTab === "discount")) && (
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        type="number"
                        name="discountValue"
                        label="Discount Amount"
                        value={values.discountValue}
                        onBlur={handleBlur}
                        disabled={fieldsLocked}
                        onChange={(e) => {
                          if (fieldsLocked) return;
                          if (Number(e.target.value) > Number(values.price)) {
                            toast.error("Discount can not be more then price");
                            return;
                          }
                          handleChange(e);
                          recalculatePrice(
                            Number(values.price) || 0,
                            Number(e.target.value) || 0,
                          );
                        }}
                        sx={styles.removeArrow}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">₹</InputAdornment>
                          ),
                        }}
                        helperText="Flat discount (not percentage)"
                      />
                    </Grid>
                  )}

                {!isEditMode && pricingTab === "coupon" && (
                  <Grid item xs={12} md={4}>
                    <Autocomplete
                      disabled={fieldsLocked || !hasCategory}
                      options={couponOptions}
                      loading={couponSearchLoading}
                      filterOptions={(options) => options}
                      value={
                        couponOptions.find(
                          (item) => item.couponCode === values.couponCode,
                        ) || null
                      }
                      onChange={(_, value) => {
                        if (fieldsLocked) return;
                        setFieldValue("couponCode", value?.couponCode || "");
                        setFieldValue(
                          "couponId",
                          value?._id || value?.id || "",
                        );
                        const servicePrice = Number(values.price) || 0;
                        recalculatePrice(
                          servicePrice,
                          computeDiscountAmount(
                            servicePrice,
                            "coupon",
                            0,
                            value,
                          ),
                        );
                      }}
                      onInputChange={(_, inputValue, reason) => {
                        if (fieldsLocked || !hasCategory) return;
                        if (reason === "reset") return;
                        const categoryName =
                          values.serviceCategory || couponCategoryRef.current;
                        if (!categoryName) return;
                        const currentSelected =
                          couponOptions.find(
                            (item) => item.couponCode === values.couponCode,
                          ) || null;
                        searchCoupons(
                          categoryName,
                          inputValue,
                          currentSelected,
                        );
                      }}
                      getOptionLabel={(option: any) => option?.couponCode || ""}
                      renderOption={(props, option: any) => (
                        <li {...props} key={option._id || option.couponCode}>
                          <Box
                            display="flex"
                            alignItems="center"
                            gap={1}
                            width="100%"
                          >
                            <Typography component="span">
                              {option.couponCode}
                              {option.title ? ` — ${option.title}` : ""}
                            </Typography>
                            {option.isDefault ? (
                              <Chip
                                size="small"
                                color="success"
                                label="Default"
                                sx={{ height: 22, fontWeight: 600 }}
                              />
                            ) : null}
                          </Box>
                        </li>
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option?.couponCode === value?.couponCode
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="couponCode"
                          variant="outlined"
                          label="Coupon Code"
                          onBlur={handleBlur}
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                              <>
                                {params.InputProps.startAdornment}
                                {selectedCoupon?.isDefault ? (
                                  <Chip
                                    size="small"
                                    color="success"
                                    label="Default"
                                    sx={{
                                      height: 22,
                                      fontWeight: 600,
                                      mr: 0.5,
                                    }}
                                  />
                                ) : null}
                              </>
                            ),
                          }}
                          helperText={
                            !hasCategory
                              ? "Select a category to load coupons"
                              : selectedCoupon
                                ? selectedCoupon.isPercentage
                                  ? `${selectedCoupon.couponValue}% off`
                                  : `${formatCurrency(Number(selectedCoupon.couponValue))} off`
                                : "Type to search coupons by code"
                          }
                        />
                      )}
                    />
                  </Grid>
                )}

                <Grid item xs={12} md={8}>
                  {priceDetails.servicePrice !== "0" ? (
                    <Box
                      sx={{
                        p: 2,
                        borderRadius: 2,
                        bgcolor: "grey.50",
                        border: "1px solid",
                        borderColor: "divider",
                      }}
                    >
                      <Typography fontWeight={700} mb={1}>
                        Amount Summary
                      </Typography>
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        mb={0.5}
                      >
                        <Typography color="text.secondary">
                          Service Price
                        </Typography>
                        <Typography>
                          {formatCurrency(+priceDetails.servicePrice)}
                        </Typography>
                      </Box>
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        mb={0.5}
                      >
                        <Typography color="text.secondary">
                          {(isEditMode && !editIsFlatDiscount) ||
                            (!isEditMode &&
                              pricingTab === "coupon" &&
                              values.couponCode)
                            ? "Coupon Applied"
                            : "Discount"}
                        </Typography>
                        <Typography sx={styles.discountPrice}>
                          - {formatCurrency(+priceDetails.discount)}
                        </Typography>
                      </Box>
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        mb={0.5}
                      >
                        <Typography color="text.secondary">
                          Taxes ({TAX_PERCENT}%)
                        </Typography>
                        <Typography>
                          {formatCurrency(+priceDetails.tax)}
                        </Typography>
                      </Box>
                      <Divider sx={{ my: 1 }} />
                      <Box display="flex" justifyContent="space-between">
                        <Typography fontWeight={800}>Grand Total</Typography>
                        <Typography fontWeight={800}>
                          {formatCurrency(+priceDetails.finalPrice)}
                        </Typography>
                      </Box>
                    </Box>
                  ) : (
                    <Typography color="text.secondary" mt={1}>
                      Select a service to see pricing summary.
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </SectionCard>

            <Box display="flex" justifyContent="flex-end" mt={1} mb={3}>
              <AnimateButton>
                <Button
                  disableElevation
                  size="large"
                  type="submit"
                  variant="contained"
                  sx={{ minWidth: 180 }}
                  disabled={isFullyLocked || (isEditMode && !canSubmitEdit)}
                >
                  {isEditMode ? "Update Order" : "Create Order"}
                </Button>
              </AnimateButton>
            </Box>

            <AddUserVehicleModal
              state={addVehicleModalOpen}
              setState={setAddVehicleModalOpen}
              userId={values.userId}
              vehicleType={getServiceCategoryFromCategoryName(
                values.serviceCategory,
              )}
              onSuccess={(assignResult, selected) => {
                const category = getServiceCategoryFromCategoryName(
                  values.serviceCategory,
                );
                getVechiles(
                  {
                    page: 1,
                    userId: values.userId,
                    vehicleType: category.toString(),
                  },
                  (list) => {
                    const addedId =
                      assignResult?.result?._id ||
                      assignResult?.result?.id ||
                      assignResult?._id ||
                      assignResult?.id ||
                      "";
                    const matched =
                      (list || []).find(
                        (item: any) =>
                          item.userVehicleId === addedId ||
                          item.id === addedId ||
                          item._id === addedId ||
                          (selected?.vehicleId &&
                            item.vehicleId === selected.vehicleId),
                      ) || null;
                    if (!matched) return;
                    const vehicleId =
                      matched.userVehicleId || matched.id || "";
                    setFieldValue("vechileId", vehicleId);
                    setFieldValue(
                      "vehicleRegNo",
                      matched.registrationNumber ||
                      matched.vehicleRegistrationNumber ||
                      "",
                    );
                    clearServiceSelection(setFieldValue);
                    if (vehicleId) {
                      setLoading(true);
                      dispatch(
                        getVehicleServiceList(vehicleId, () => {
                          setLoading(false);
                        }),
                      );
                    }
                  },
                );
              }}
            />

            <Dialog
              open={addressModalOpen}
              onClose={() => setAddressModalOpen(false)}
              fullWidth
              maxWidth="sm"
              disableEnforceFocus
              disableRestoreFocus
            >
              <DialogTitle sx={{ pr: 6 }}>
                Add New Address
                <IconButton
                  onClick={() => setAddressModalOpen(false)}
                  sx={{ position: "absolute", right: 8, top: 8 }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers>
                <Box mb={2}>
                  <GoogleAutComplete
                    addressHandler={(address) => {
                      const [lng = "", lat = ""] =
                        address.location?.coordinates || [];
                      setNewAddressDraft((prev) => ({
                        ...prev,
                        addressLine1: address.addressLine1 || "",
                        addressLine2: address.addressLine2 || "",
                        city: address.city || "",
                        state: address.state || "",
                        pincode: address.pincode || "",
                        latitude: lat != null ? String(lat) : "",
                        longitude: lng != null ? String(lng) : "",
                      }));
                    }}
                  />
                </Box>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Address Line 1"
                      value={newAddressDraft.addressLine1}
                      onChange={(e) =>
                        setNewAddressDraft((prev) => ({
                          ...prev,
                          addressLine1: e.target.value,
                        }))
                      }
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Address Line 2"
                      value={newAddressDraft.addressLine2}
                      onChange={(e) =>
                        setNewAddressDraft((prev) => ({
                          ...prev,
                          addressLine2: e.target.value,
                        }))
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="City"
                      value={newAddressDraft.city}
                      onChange={(e) =>
                        setNewAddressDraft((prev) => ({
                          ...prev,
                          city: e.target.value,
                        }))
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="State"
                      value={newAddressDraft.state}
                      onChange={(e) =>
                        setNewAddressDraft((prev) => ({
                          ...prev,
                          state: e.target.value,
                        }))
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="Pincode"
                      value={newAddressDraft.pincode}
                      onChange={(e) =>
                        setNewAddressDraft((prev) => ({
                          ...prev,
                          pincode: e.target.value,
                        }))
                      }
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel id="new-address-type-label" shrink>
                        Address Type
                      </InputLabel>
                      <Select
                        labelId="new-address-type-label"
                        label="Address Type"
                        notched
                        displayEmpty
                        sx={styles.selectDropdown}
                        value={newAddressDraft.addressType}
                        onChange={(e) =>
                          setNewAddressDraft((prev) => ({
                            ...prev,
                            addressType: `${e.target.value}`,
                          }))
                        }
                        renderValue={(selected) => {
                          if (!selected) return "Select address type";
                          return (
                            ADDRESS_TYPE_LABEL[
                              Number(selected) as ADDRESS_TYPE
                            ] || "Select address type"
                          );
                        }}
                      >
                        <MenuItem value="" disabled>
                          Select address type
                        </MenuItem>
                        {Object.values(ADDRESS_TYPE)
                          .filter((v) => typeof v === "number")
                          .map((type) => (
                            <MenuItem key={type} value={`${type}`}>
                              {ADDRESS_TYPE_LABEL[type as ADDRESS_TYPE]}
                            </MenuItem>
                          ))}
                      </Select>
                      <FormHelperText>
                        {newAddressDraft.addressType === ""
                          ? "Select Home, Work, or Other before using this address."
                          : "This type is sent with the new address when the order is created."}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions sx={{ px: 3, py: 2 }}>
                <Button onClick={() => setAddressModalOpen(false)}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  disabled={
                    !newAddressDraft.addressLine1 ||
                    parseSelectedAddressType(newAddressDraft.addressType) ===
                      undefined
                  }
                  onClick={() => confirmNewAddress(setFieldValue)}
                >
                  Use This Address
                </Button>
              </DialogActions>
            </Dialog>

            {loading && <Loader />}
          </form>
        );
      }}
    </Formik>
  );
};

export default CreateOrder;
